export default __webpack_public_path__ + "static/book-2f62b850788c0c0d6adb1c34e974fa2f.woff2";